<template>
  <div class="user-history-component" :style="{ width: '70%' }">
    <div class="title-container">
      <h2 class="title">User Rewards</h2>
    </div>

    <div class="button-container">
      <router-link to="/Reward-Page/month" class="info-button">Month</router-link>
      <router-link to="/Reward-Page/recent" class="info-button">Recent</router-link>

    </div>

    <div class="line-container">
      <hr class="line" />
    </div>

    <div class="info-container">

      <router-view>

        <div v-if="$route.path === '/Reward-Page/month'">

          <div class="column">
            <h3>Month</h3>
            <ul>
              <li>May</li>
              <li>April</li>
              <li>March</li>
              <li>February</li>
              <li>January</li>
            </ul>
          </div>
          <div class="column">
            <h3>Reward</h3>
            <ul>
              <li>0.00</li>
              <li>0.00</li>
              <li>0.00</li>
              <li>0.00</li>
              <li>0.00</li>
            </ul>
          </div>
        </div>


        <div v-if="$route.path === '/Reward-Page/recent'">
          <h3>Reward Page</h3>
          <p>This is the content for the Rewards recent page.</p>
        </div>



      </router-view>
    </div>
  </div>
</template>

<style scoped>
.user-history-component {
  width: 70%;
}

.title-container {
  display: flex;
  justify-content: flex-start;
}

.title {
  margin-top: 1;

}

.line-container {
  position: relative;
}

.line {
  border: none;
  height: 4px;
  background-color: black;
  position: absolute;

  left: 0;
  right: 0;
  transform: translateY(-800%);
  z-index: 0;
}

.button-container {
  display: flex;
  justify-content: center;

}

.info-button {
  margin: 0 0px;
  border-radius: 0%;
  background-color: black;
  border-color: white;
  z-index: 2;
}

.info-container {
  margin-top: 20px;
}

.info {
  margin: 0;
}



.tableContainer {
  display: flex;
}

.column {
  flex: 1;
  padding: 15px;
}

.column h3 {
  text-align: center;
}

.column ul {
  list-style: none;
  padding: 0;
}

.column li {
  margin-bottom: 30px;
}
</style>
